<template>
  <span v-if="isCustomCurrencySelected">
    {{ (item.priceInBaseCurrency * ($root.$account.currency ? $root.$account.currency.rate : 1)).toFixed(2) }} {{ $root.$account.currency ? $root.$account.currency.code : 'EUR' }}
    ({{ item.priceInBaseCurrency }} {{ $settings.base_currency.code }})
  </span>
  <span v-else>
    {{ item.priceInBaseCurrency }} {{ $settings.base_currency.code }}
  </span>
</template>

<script>
import ValueMixin from './ValueMixin'

export default {
  name: 'ValuePriceWithCurrency',

  mixins: [ValueMixin],

  computed: {
    isCustomCurrencySelected() {
      return this.$settings.base_currency && this.$root.$account.currency &&
        this.$settings.base_currency.code !== this.$root.$account.currency.code
    }
  }
}
</script>
